import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createInternalTransfer } from '@/api/transferApi'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useCreateInternalTransfer = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createInternalTransfer,
    onSuccess: () => {
      // Invalidate relevant queries to refresh data
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.WALLET] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TRANSACTIONS] })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.PAYMENT_REQUESTS_HISTORY],
      })
    },
    onError: () => {},
  })
}
